import CreateOpenPlay from './CreateOpenPlay';

// The form reads the route id and switches to edit mode when it is present.
export default function EditOpenPlay() {
  return <CreateOpenPlay />;
}
